'use strict';

/**
 * Collection of constants related with the select component.
 * @typedef SelectConstants
 * @property {Object} OPTIONS Collection of available select options.
 * @property {Select2.OptionData} OPTIONS.default Default select options.
 * @property {Select2.OptionData} OPTIONS.search Default select options with search functionality.
 * @property {Select2.OptionData} OPTIONS.borderless_hide_selected Select without showing the selected option and without border at the selected option.
 */

/**
 * @type {SelectConstants}
 */
module.exports = {
    OPTIONS: {
        default: {
            dropdownAutoWidth: true,
            minimumResultsForSearch: -1
        },
        search: {
            width: 'element',
            dropdownAutoWidth: true,
            minimumResultsForSearch: 0,
            closeOnSelect: false
        },
        borderless_hide_selected: {
            width: 'auto',
            dropdownAutoWidth: true,
            minimumResultsForSearch: -1,
            theme: 'borderless-hide-selected'
        },
        sorting: {
            width: 'auto',
            dropdownAutoWidth: true,
            minimumResultsForSearch: -1,
            theme: 'sorting'
        }
    }
};
